// PHASE 5: How do you process new information?
import SingleChoiceQuestionPage from '@app-studio-web/ui/pages/SingleChoiceQuestionPage'
import { AnswerType } from '@app-studio-web/ui/types'

const answers: AnswerType[] = [
  {
    emoji: '🔍',
    title: 'pages.onboarding.cognitiveStyle.answer1',
    subtitle: 'pages.onboarding.cognitiveStyle.answer1Subtitle',
  },
  {
    emoji: '🎯',
    title: 'pages.onboarding.cognitiveStyle.answer2',
    subtitle: 'pages.onboarding.cognitiveStyle.answer2Subtitle',
  },
  {
    emoji: '🧩',
    title: 'pages.onboarding.cognitiveStyle.answer3',
    subtitle: 'pages.onboarding.cognitiveStyle.answer3Subtitle',
  },
  {
    emoji: '🔄',
    title: 'pages.onboarding.cognitiveStyle.answer4',
    subtitle: 'pages.onboarding.cognitiveStyle.answer4Subtitle',
  },
]

export default function CognitiveStylePage() {
  return (
    <SingleChoiceQuestionPage
      answers={answers}
      title="pages.onboarding.cognitiveStyle.title"
      subtitle="pages.onboarding.cognitiveStyle.subtitle"
    />
  )
}
